import { CLIMATIZACAO_DESCRICOES, CLIMATIZACAO_LABELS, CLIMATIZACOES, type Climatizacao } from '@adega/shared';

/**
 * Escolha da climatização da adega, com o que cada opção significa para o vinho.
 *
 * A descrição não é enfeite: a diferença entre compressor e termoelétrica muda a
 * janela de guarda, e quase ninguém sabe isso de cabeça na hora de cadastrar.
 *
 * Não existe opção "não informado": o estado inicial já é esse. Um botão para
 * voltar a "não sei" seria mais confuso do que útil — quem informou errado só
 * troca a opção.
 */
export function EscolhaClimatizacao({
  valor,
  onChange,
  disabled,
}: {
  valor: Climatizacao | null;
  onChange: (valor: Climatizacao) => void;
  disabled?: boolean;
}) {
  return (
    <div role="radiogroup" aria-label="Climatização da adega" className="space-y-2">
      {CLIMATIZACOES.map((opcao) => {
        const selecionada = valor === opcao;
        return (
          <button
            key={opcao}
            type="button"
            role="radio"
            aria-checked={selecionada}
            disabled={disabled}
            onClick={() => onChange(opcao)}
            className={`w-full rounded-xl border p-3 text-left transition disabled:opacity-60 ${
              selecionada
                ? 'border-adega-gold/60 bg-adega-gold/10'
                : 'border-white/10 bg-adega-surface-2'
            }`}
          >
            <span className={`block text-sm font-medium ${selecionada ? 'text-adega-gold' : ''}`}>
              {CLIMATIZACAO_LABELS[opcao]}
            </span>
            <span className="mt-0.5 block text-xs leading-relaxed text-adega-muted">
              {CLIMATIZACAO_DESCRICOES[opcao]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
